import useResource from "./useResource"

import { isAValue } from "web/services/helpers"
import { pluralize } from "web/services/inflector"

export default function useTLO(subjectType, id) {
  const paramsValid = isAValue(subjectType) && isAValue(id)

  const key = paramsValid ? `/${pluralize(subjectType)}/${id}` : undefined
  const listKey = paramsValid ? `/${pluralize(subjectType)}` : undefined

  const [tlo] = useResource({
    key,
    parentKeys: [listKey],
    resourceType: subjectType,
  })

  function userCan(action) {
    return tlo.user_permissions[action]
  }

  if (tlo) {
    tlo.userCan = userCan
  }

  return tlo
}
